/** Mantém só dígitos */
export function digitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

/** Mantém alfanuméricos (CPF/CNPJ novos) */
export function alphanumericOnly(value: string): string {
  return value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
}

/**
 * Telefone BR: (XX) XXXX-XXXX (fixo) ou (XX) 9XXXX-XXXX (celular).
 */
export function formatPhoneBR(value: string): string {
  const d = digitsOnly(value).slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  }
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export function phoneToApi(value: string): string {
  const d = digitsOnly(value);
  return d ? `+55${d}` : '';
}

export type DocumentKind = 'cpf' | 'cnpj' | 'unknown';

export function detectDocumentKind(raw: string): DocumentKind {
  const v = alphanumericOnly(raw);
  if (!v) return 'unknown';
  if (/[A-Z]/.test(v)) return 'cnpj';
  if (v.length > 11) return 'cnpj';
  return 'cpf';
}

/**
 * CPF: 000.000.000-00 (11 dígitos)
 * CNPJ: XX.XXX.XXX/XXXX-XX (14 alfanuméricos — novo padrão BR)
 */
export function formatDocumentBR(value: string): string {
  const v = alphanumericOnly(value);
  if (!v) return '';

  const kind = detectDocumentKind(v);

  if (kind === 'cpf') {
    const d = v.replace(/\D/g, '').slice(0, 11);
    if (d.length <= 3) return d;
    if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
    if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  }

  const c = v.slice(0, 14);
  if (c.length <= 2) return c;
  if (c.length <= 5) return `${c.slice(0, 2)}.${c.slice(2)}`;
  if (c.length <= 8) return `${c.slice(0, 2)}.${c.slice(2, 5)}.${c.slice(5)}`;
  if (c.length <= 12) return `${c.slice(0, 2)}.${c.slice(2, 5)}.${c.slice(5, 8)}/${c.slice(8)}`;
  return `${c.slice(0, 2)}.${c.slice(2, 5)}.${c.slice(5, 8)}/${c.slice(8, 12)}-${c.slice(12)}`;
}

export function documentToApi(value: string): string {
  return alphanumericOnly(value);
}

export function documentKindLabel(kind: DocumentKind): string {
  if (kind === 'cpf') return 'CPF';
  if (kind === 'cnpj') return 'CNPJ';
  return '';
}
